export default [
    {
        path: 'procedimento-consolidado',
        component: () => import(/* webpackChunkName: 'bpa-procedimento-consolidado' */ '@/views/bpa/procedimento-consolidado/Index'),
        redirect: 'procedimento-consolidado/index',
        children: [
            {
                name: 'bpa-procedimento-consolidado-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'bpa-procedimento-consolidado' */ '@/views/bpa/procedimento-consolidado/List.vue'),
            },
            {
                name: 'bpa-procedimento-consolidado-create',
                path: 'create',
                component: () => import(/* webpackChunkName: 'bpa-procedimento-consolidado' */ '@/views/bpa/procedimento-consolidado/Form.vue'),
            },
            {
                name: 'bpa-procedimento-consolidado-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(/* webpackChunkName: 'bpa-procedimento-consolidado' */ '@/views/bpa/procedimento-consolidado/Form.vue'),
            },
        ],
    },
]